import { useEffect, useState } from 'react';
import { AlertElementElementModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface IAlertProps {
    alert: AlertElementElementModel;
}

const Alert = ({ alert }: IAlertProps) => {
    const [theme, setTheme] = useState<string>();

    useEffect(() => {
        switch (alert.properties?.alertType?.color) {
            case '198754':
                setTheme('alert-success');
                break;
            case 'ffc107':
                setTheme('alert-warning');
                break;
            case 'dc3545':
                setTheme('alert-danger');
                break;
            case 'ececec':
                setTheme('alert-light');
                break;
            default:
                setTheme('alert-info');
                break;
        }
    }, [alert.properties]);

    return (
        <div
            className={`alert ${theme} mb-0`}
            role='alert'
        >
            <h5 className='alert-heading'>
                {alert.properties?.icon ?
                    alert.properties.icon.startsWith('mdi') ?
                    <span className={`mdi mr-1 ${alert.properties.icon} font-size-xxl`}></span>:
                    <span
                    className="material-icon mr-1 material-symbols-outlined font-size-xxl`">{alert.properties.icon}</span>
                    
                    :null}
            {alert.properties?.heading}
        </h5>
            {alert.properties?.text?.markup && <div dangerouslySetInnerHTML={{ __html: alert.properties.text.markup }} />}
            {alert.properties?.link && (
                <div className='d-flex flex-wap gap-2'>
                    {alert.properties.link.map((link, key) => {
                        return (
                            <a
                                key={key}
                                href={link.url ?? link.route?.path}
                                className='btn btn-primary btn-sm mt-3'
                                target={link.target ?? ''}
                                title={link.title ?? ''}
                                rel='noreferrer'
                            >
                                {link.title}
                            </a>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Alert;
